import * as ng from 'angular';
import { WizardObject } from '../../wizard-supervisor/wizard-supervisor';

export class MoleculeWizardSummaryItemCertificateController implements ng.IController {
    public static $inject: string[] = [];
    public serviceObject: WizardObject;
}

export class MoleculeWizardSummaryItemCertificateComponent implements ng.IComponentOptions {
    public bindings = {
        serviceObject: '='
    };
    public template = require('./wizard-summary-certificate.html');
    public controller =  MoleculeWizardSummaryItemCertificateController;
}
